export default __webpack_public_path__ + "static/fan-illustration-dark-45ce8941ef5fc3f903709d2df1d0608b.svg";